import { Component, signal } from '@angular/core';
import { Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { Subject, debounceTime, filter, firstValueFrom, of, switchMap } from 'rxjs';
import { PatientAPI } from 'src/app/features/medical-record/medical-record-page/pages/patient-informations/model/patient.model';
import { MedicalRecordService } from 'src/app/features/medical-record/services/medical-record.service';
import { MedicalRecordState } from 'src/app/features/medical-record/store/medical-record.state';
import { PatientService } from 'src/app/shared/services/patient/patient-info.service';
import { Alerts } from '../../../alerts/alert';
import { TabsStateService } from 'src/app/features/medical-record/services/tabs-state.service';
import { EnumPartialRoutes } from 'src/app/shared/enums/enums';

@Component({
  selector: 'app-search-input',
  templateUrl: './search-input.component.html',
  styleUrls: ['./search-input.component.scss'],
})
export class SearchInputComponent {
  searchingPatient: boolean = false;
  searchInputText: string = '';
  backgroundOn = false;
  patientsResult = signal<PatientAPI[]>([]);
  searchTerm$ = new Subject<string>();
  loadingPatient: boolean = true;

  constructor(
    private patientService: PatientService,
    private router: Router,
    private medicalRecordService: MedicalRecordService,
    private alerts: Alerts,
    private tabsState: TabsStateService
  ) {
    this.searchTerm$
      .pipe(
        debounceTime(200),
        filter(x => x.length > 2),
        switchMap(st => this.isInputValueNumeric(st) ? of({ identifier: st }) : of({ name: st })))
      .subscribe(async searchObj => {
        this.searchingPatient = true
        this.loadingPatient = true;
        this.patientsResult.set([])

        try {
          const res = await this.patientService.searchPatients(searchObj);
          if (res.status !== 'ok') {
            throw new Error(res.internalStatusCode)
          }

          const resultFiltered = res.result.filter(pat => {
            if (this.isInputValueNumeric(this.searchInputText)) {
              return true
            }
            return this.patientNameIncludesSearchTerm(pat, this.searchInputText)
          });
          this.patientsResult.set(resultFiltered.sort((a, b) => {
            const firstName = a.name[0].text.split(' ')[0];
            const secondName = b.name[0].text.split(' ')[0];
            return secondName.localeCompare(firstName)
          })

          )

        } catch (e) {
          console.error(e)
        }



        this.loadingPatient = false;
        this.searchingPatient = false;

      });
  }

  patientNameIncludesSearchTerm = (pat: PatientAPI, searchTerm: string) => pat.name[0].text.toLowerCase().includes(searchTerm.toLowerCase())

  private isInputValueNumeric = (x: string): boolean => {
    const numericRegex: RegExp = /^[0-9]+$/;
    return numericRegex.test(x);
  }

  onSearchTermChange(term: string): void {
    this.searchTerm$.next(term);
    this.searchInputText = term
  }

  onInputFocus() {
    this.backgroundOn = true
  }

  onBlur() {
    if (this.patientsResult().length === 0) {
      this.backgroundOn = false
    }
  }

  async selecPatient(patient: PatientAPI | null, isChangingPage?: boolean) {
    this.medicalRecordService.isMedicalRecordOpen.subscribe(isOpen => {
      if (isOpen) {
        this.alerts.alertWithOneButton('error', 'Alterações em progresso', 'Antes de trocar de paciente, salve as alterações efetuadas.', 'Ok');
        return
      }
      if (!isChangingPage && patient) {
        this.selectPatient(patient)
        return
      }
      this.navigateToSchedule()
    }).unsubscribe();

  }

  selectPatient(patient: PatientAPI) {

    this.patientService.setSelectedPatientById(patient.id)
    this.patientsResult.set([]);
    this.searchTerm$.next('');
    this.backgroundOn = false;
    this.searchInputText = '';
    this.tabsState.changeTab("diagnóstico")

    if (this.router.url == '/schedule/day-view') {
      this.router.navigate([EnumPartialRoutes.MEDICAL_RECORD]);
    }
  }

  navigateToSchedule() {
    this.patientService.setSelectedPatientById(null)
    this.router.navigate([EnumPartialRoutes.SCHEDULE_DAY_VIEW]);
  }

  resetSearch() {
    this.patientsResult.set([])
    this.backgroundOn = false;
    this.searchTerm$.next('')
    this.searchInputText = ''
  }
}
